/* 09.15.2026. The pre-order note is gone. This file used to inject '◆ Pre-order now · ships the
   week of September 21' under every add to cart button, into the cart drawer and onto the cart
   page, and to rewrite the announcement bar text. All four are removed under the no pre-order,
   no ship date rule [LF:no-preorder-no-shipdate 09.15]. Because it injected client side, a
   server-side crawl of the site could not see any of it, which is how it survived the sweep.
   What remains is the one real feature: real pouch photos on the drawer cross-sell tiles. */
(function(){
  var POUCH={
    'TA':'https://cdn.shopify.com/s/files/1/0824/3629/2864/files/PDP_Trans_Tapas_12g_2200_1b7a116a-d547-4323-a58f-0378902735f3.png?v=1786705885',
    'ME':'https://cdn.shopify.com/s/files/1/0824/3629/2864/files/PDP_Trans_Mezze_12_g_2200_04d64c55-bfbd-4150-bca7-46e070c252cc.png?v=1786705876',
    'AP':'https://cdn.shopify.com/s/files/1/0824/3629/2864/files/PDP_Trans_Aperitivo_12g_2200_a0fb3f2e-e39e-4b7c-b39c-ecc5e7e775cc.png?v=1786705896'
  };
  function fixPouches(){
    var ps=document.querySelectorAll('.wbcb-pouch');
    for(var i=0;i<ps.length;i++){
      var p=ps[i]; if(p.getAttribute('data-wb-img'))continue;
      var sp=p.querySelector('span'); var key=sp?(sp.textContent||'').trim().toUpperCase().slice(0,2):'';
      var url=POUCH[key]; if(!url)continue;
      p.setAttribute('data-wb-img','1');
      p.style.backgroundImage='url(\''+url+'\')';
      p.style.backgroundSize='contain';p.style.backgroundRepeat='no-repeat';p.style.backgroundPosition='center';
      if(sp)sp.style.color='transparent';
    }
  }
  /* Belt and braces: if any older cached copy of this script, or a stale rendered fragment,
     puts a pre-sale note back on the page, take it out rather than leave it visible. */
  function sweepOldNotes(){
    var n=document.querySelectorAll('.wb-presale-note');
    for(var i=0;i<n.length;i++){
      var el=n[i];
      if(el.classList.contains('wbb-note-static'))continue;
      if(/pre-?order|september|sept\s*21|ships the week/i.test(el.textContent||''))el.remove();
    }
  }
  function run(){fixPouches();sweepOldNotes();}
  if(document.readyState!=='loading'){run();}else{document.addEventListener('DOMContentLoaded',run);}
  try{var mo=new MutationObserver(run);mo.observe(document.body,{childList:true,subtree:true});}catch(e){}
})();
